import { StyleSheet, ViewStyle } from "react-native"
import { color, palette, spacing, dimensions } from "../../theme"

/**
 * All buttons will start off looking like this.
 */
const baseStyles: ViewStyle = {
  alignItems: "center",
  alignSelf: "flex-start",
  borderRadius: dimensions.buttonRadius,
  flexDirection: "row",
  height: 56,
  justifyContent: "center",
  paddingHorizontal: spacing[5],
}

// Button Variation Styles
export const viewPresets = StyleSheet.create({
  /**
   * Button with darkPurple background no border.
   */
  primary: { ...baseStyles, backgroundColor: color.primary },

  /**
   * Button with lightblue background no border.
   */
  secondary: { ...baseStyles, backgroundColor: color.secondary },

  /**
   * Button with white background and border.
   */
  tertiary: {
    ...baseStyles,
    backgroundColor: palette.white,
    borderColor: color.formElement,
    borderWidth: spacing[1] / 2,
  },

  text: {
    ...baseStyles,
    height: 40,
    paddingHorizontal: spacing[2],
    paddingVertical: spacing[2],
  },
})

export const textPresets = StyleSheet.create({
  /**
   * Button with white text.
   */
  primary: { color: palette.white },

  /**
   * Button with darkPurple text.
   */
  secondary: { color: color.primary },

  /**
   * Button with darkPurple text.
   */
  tertiary: { color: color.primary },

  /**
   * Button is just text
   */
  text: { color: color.primary },
})

/**
 * A list of preset names. the text preset names and view preset names should always match for this component
 */
export type ButtonPresetNames = keyof typeof viewPresets
